import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/assets/images/logo.png" alt="Physero" className="footer-logo" />
            <p>Providing quality healthcare services at your doorstep with experienced professionals.</p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#services">Services</a></li>
              <li><a href="#physiotherapists">Our Team</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              {/* <li><a href="#booking">Book Now</a></li> */}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              <li><a href="#">Orthopedic Physiotherapy</a></li>
              <li><a href="#">Sports Injury</a></li>
              <li><a href="#">Post-Operative Care</a></li>
              <li><a href="#">Neurological</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <div className="contact-info">
              <p>📞 1800-102-4224</p>
              <p>📧 info@Physero.com</p>
              <p>🌐 www.physero.com</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms and Conditions</a>
            <a href="#">FAQs</a>
          </div>
          <div className="footer-copyright">
            <p>&copy; 2024 Physero Medical. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;